export default "__VITE_ASSET__8KEcGQkn__"